import SkeletonGroup from 'components/loaders/SkeletonGroup';
import SkeletonText from 'components/loaders/SkeletonText';

const DetailsViewCardApplicationListItemSkeleton = () => (
    <>
        <SkeletonGroup>
            <SkeletonText lines={1} />

            <SkeletonText lines={1} />
        </SkeletonGroup>
    </>
);

export default DetailsViewCardApplicationListItemSkeleton;
